export default {
  missingMarkets: {
    id: 'listing_detail_comments_missing_markets',
    defaultMessage: 'Those markets have missing comments:',
  },
  market: {
    id: 'listing_detail_comments_market',
    defaultMessage: 'Market',
  },
  commentsSection: {
    id: 'listing_detail_comments_section',
    defaultMessage: 'Comment Section',
  },
  commentLevel: {
    id: 'listing_detail_comments_comment_level',
    defaultMessage: 'Comment Level',
  },
  comments: {
    id: 'listing_detail_comments_comments',
    defaultMessage: 'Comments',
  },
  fetchingData: {
    id: 'listing_detail_comments_fetching_data',
    defaultMessage: 'We are fetching the data...',
  },
  delete: {
    id: 'listing_detail_comments_delete',
    defaultMessage: 'Delete',
  },
  toastErrorTitle: {
    id: 'listing_detail_toast_error_title',
    defaultMessage: 'Oops!',
  },
  toastErrorContent: {
    id: 'listing_detail_toast_error_generic_content',
    defaultMessage: 'We are sorry, something went wrong!',
  },
  toastSuccessTitle: {
    id: 'listing_detail_toast_success_title',
    defaultMessage: 'Well done!',
  },
  toastSuccessContent: {
    id: 'listing_detail_toast_succcess_content',
    defaultMessage: 'The comment is now deleted!',
  },
  infoText: {
    id: 'listing_detail_comments_info_text',
    defaultMessage:
      'You can add new comments at the listing level or manage your comments at the category level on the Options tab. ',
  },
  manageCommentsButton: {
    id: 'listing_detail_comments_manage_comments_button',
    defaultMessage: 'Manage comments in Options',
  },
  addCommentButton: {
    id: 'listing_detail_comments_add_comment_button',
    defaultMessage: 'Add comments to this listing',
  },
  noResults: {
    id: 'listing_detail_comments_no_results',
    defaultMessage: 'No comments found',
  },
  // add comment

  addCommentFormTitle: {
    id: 'listing_detail_comments_add_comment_form_title',
    defaultMessage: 'Add a new comment for this listing',
  },
  addFormSection: {
    id: 'listing_detail_comments_add_comment_form_label',
    defaultMessage: 'Add comment form',
  },
  addCommentFormDescription: {
    id: 'listing_detail_comments_add_comment_form_description',
    defaultMessage:
      'When you add a comment at the listing level, it will replace any existing comment for that listing in all markets.',
  },
  addCommentFormMarketLabel: {
    id: 'listing_detail_comments_add_comment_form_market_label',
    defaultMessage: 'Market',
  },
  addCommentFormCommentLabel: {
    id: 'listing_detail_comments_add_comment_form_comment_label',
    defaultMessage: 'Your comment',
  },
  addCommentFormAddButton: {
    id: 'listing_detail_comments_add_comment_form_add_button',
    defaultMessage: 'Add comment to this listing',
  },
  addFormMarketSelectLabel: {
    id: 'listing_detail_comments_add_comment_form_select_market_label',
    defaultMessage: 'Market',
  },
  addFormMarketCommentInputLabel: {
    id: 'listing_detail_comments_add_comment_form_comment_input_label',
    defaultMessage: 'Comment',
  },
  addCommentFormCancelButton: {
    id: 'listing_detail_comments_add_comment_form_cancel_button',
    defaultMessage: 'Cancel',
  },
  formMandatoryError: {
    id: 'listing_detail_comments_add_comment_form_field_error',
    defaultMessage: 'This field is mandatory',
  },
  commentFieldLenghtLimit: {
    id: 'listing_detail_comments_add_comment_form_comment_input_length',
    defaultMessage: '{length} characters left',
  },
}
